// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#scaleratio-control {\n    position: absolute;\n    left: .5em;\n    bottom: 2.5em;\n    padding: 2px;\n    border-radius: 4px;\n    background-color: rgba(183, 200, 0, 0.75) !important;\n    text-align: center;\n    max-width: max-content;\n    z-index: 2000;\n}\n#scaleratio-control input {\n    background: none;\n    color: white;\n    border: 0;\n    width: 8em;\n    text-align: center;\n}", ""]);
// Exports
module.exports = exports;
